var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-rank skeleton-rank"},[_c('div',{staticClass:"x-rank__menu"},_vm._l((8),function(i){return _c('p',{key:i,staticClass:"x-rank__menu--item s-skeleton__rect--small"})}),0),_c('div',{staticClass:"x-rank__list"},_vm._l((8),function(i){return _c('s-book-multi',{key:i,staticClass:"x-rank__book van-hairline--bottom"})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }